module.exports = __webpack_public_path__ + "static/media/ImageComments.c3fb7160.svg";